import { Grid, TextField, Typography } from '@material-ui/core';
import { SearchIcon } from 'components/Icons';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import useStyle from './style';

export default function () {
  const { t } = useTranslation();
  const classes = useStyle();
  const { evento, pesquisar, termoPesquisa } = useContext(MensagensContext);
  // const [isLoading, setLoading] = useState<boolean>(false);
  const title = useRef<HTMLHeadingElement>(null);
  // const dispatch = useDispatch();

  // const habilitarForum = useCallback(async () => {
  //   if (!evento) return;
  //   setLoading(true);
  //   const { fail, response } = await api.mensagens.liberar(evento.id);
  //   setLoading(false);
  //   if (fail) {
  //     ErrorHandler(fail);
  //   }
  //   if (response && response.status === 200) {
  //     atualizarEvento();
  //   }
  // }, [evento, atualizarEvento]);

  // const desabilitarForum = useCallback(async () => {
  //   if (!evento) return;
  //   setLoading(true);
  //   const { fail, response } = await api.mensagens.bloquear(evento.id);
  //   setLoading(false);
  //   if (fail) {
  //     ErrorHandler(fail);
  //   }
  //   if (response && response.status === 200) {
  //     atualizarEvento();
  //   }
  // }, [evento, atualizarEvento]);

  // const incluirPergunta = useCallback(() => {
  //   if (!evento) return;
  //   const modalKey = getUniqueKey();
  //   dispatch(
  //     modalsActionsOpen(
  //       IncluirPerguntaChatModal,
  //       {
  //         genericProps: {
  //           key: modalKey,
  //           idEvento: evento.id,
  //           callbackSuccess: () => atualizarMensagens(),
  //         },
  //       } as IIncluirPerguntaChatModal,
  //       modalKey
  //     )
  //   );
  // }, [dispatch, evento, atualizarMensagens]);

  return (
    <Grid item sm={12} md={12} lg={12} className={classes.root} component="header">
      <div>
        <div className={classes.headline}>
          <Typography className={classes.title} component="h1" ref={title}>
            {evento?.nome}
          </Typography>
        </div>
      </div>
      <div className={classes.actionsRow}>
        <div className={classes.search}>
          <TextField
            label={t('AssessorMensagens.search')}
            className={classes.input}
            InputProps={{
              endAdornment: <SearchIcon />,
            }}
            value={termoPesquisa}
            onChange={e => pesquisar(e.currentTarget.value)}
            fullWidth
          />
        </div>
        {/* <div className={classes.actionButtons}>
          {auth?.incluirPergunta && (
            <Button
              variant="contained"
              className={classes.actionButton}
              onClick={() => incluirPergunta()}
              disabled={isLoading || habilitandoDesabilitando}
            >
              {t(`AssessorMensagens.incluirMensagem`)}
            </Button>
          )}
          {auth?.alterarSituacao && (
            <Button
              variant="contained"
              className={classes.actionButton}
              onClick={() => (evento?.statusChat ? desabilitarForum() : habilitarForum())}
              endIcon={isLoading || habilitandoDesabilitando ? <SyncIcon animated /> : undefined}
              disabled={isLoading || habilitandoDesabilitando}
            >
              {t(`AssessorMensagens.${evento?.statusChat ? 'forum-desabilitar' : 'forum-habilitar'}`)}
            </Button>
          )}
        </div> */}
      </div>
    </Grid>
  );
}
